module.exports = __webpack_public_path__ + "static/media/2-1.bb827e69.png";